import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Stack, Title, Text, useMantineTheme, Box, } from "@mantine/core";
import CheckGreen from "../assets/icons.generated/CheckGreen";
import ErrorTriangle from "../assets/icons.generated/ErrorTriangle";
import { STATUS_COLOR } from "../theme/colors";
const AlertBox = ({ type = "error", title, footer, children, ...rest }) => {
    const theme = useMantineTheme();
    return (_jsx(Box, { ta: "center", ...rest, children: _jsxs(Stack, { align: "center", children: [type === "error" ? (_jsx(ErrorTriangle, { width: 32, height: 32, color: theme.fn.themeColor(STATUS_COLOR.ERROR) })) : (_jsx(CheckGreen, { width: 32, height: 32 })), _jsx(Title, { order: 5, children: title }), _jsx(Text, { size: "sm", children: children }), _jsx("div", { children: footer })] }) }));
};
export default AlertBox;
